import { tEnglish as t } from "@buza/i18n";
import type { StaffSession } from "../signin/session.js";

// Who is signed in, their parlour and role, and Sign out (S-007). The shell (S-043) shows it in its
// header on every parlour screen.
export function SignedInBar({ session, onSignOut }: { session: StaffSession; onSignOut: () => void }) {
  return (
    <div className="signed-in">
      <p>
        {t("parlour.shell.signed_in_as")} <strong>{session.name}</strong>
      </p>
      {session.tenantName && <p className="tenant-name">{session.tenantName}</p>}
      <p className="role">{t(session.role === "owner" ? "parlour.shell.role_owner" : "parlour.shell.role_staff")}</p>
      <button type="button" onClick={onSignOut}>
        {t("parlour.shell.sign_out")}
      </button>
    </div>
  );
}
